import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

const { carbon } = colorsPalettes;

export const Container = styled(Stack)`
    width: 100%;
    overflow: hidden;
    padding: 0;
    gap: 8px;
    position: relative;
    cursor: pointer;
`;

export const LoadingContainer = styled(Stack)<{ $isGrid?: boolean }>`
    width: 100%;
    overflow: hidden;
    justify-content: end;

    ${({ $isGrid }) =>
        $isGrid
            ? `
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 8px;
        align-content: start;        
        `
            : ""};
`;

export const LoaderItem = styled(Stack)`
    width: 100%;
    gap: 8px;
    overflow: hidden;
`;

export const LoadingShare = styled(Stack)`
    gap: 4px;
`;

export const ChartContainer = styled.div`
    width: 100%;
    margin-top: 0;
`;

export const MetricRow = styled(Flex)`
    align-items: center;
    gap: 4px;
`;

export const Share = styled.span`
    ${setFontVariant("h4", carbon[500])};
`;

export const Difference = styled(Flex)`
    justify-content: flex-start;

    .change-indication__value {
        font-size: 14px;
    }

    @media screen and (max-width: 1350px) {
        .change-indication__value {
            font-size: 12px;
        }
    }
`;
